import { ImporterOfRecordContactInformationModel } from '@data-layer/models/companies';
import { UserModel } from '@data-layer/models/user';

export function normalizeIorText(value: string | null | undefined): string {
  return (value ?? '').toString().trim().toLowerCase();
}

export function normalizeIorPhone(value: string | null | undefined): string {
  return (value ?? '').toString().replace(/\D/g, '');
}

/**
 * Strict 4-field equality between IOR data and the current user. Returns false
 * when the user profile has no phone — by contract, callers that prompt the
 * match-confirmation modal also require a phone to land on the user-as-IOR path
 * (the POA edit sidebar enforces `Validators.required` on phoneNumber). The
 * legacy company-edit form keeps its own lenient comparison inline because it
 * has a phone-required sub-modal flow that this helper does not model.
 */
export function isIorMatchingUser(
  ior: Partial<ImporterOfRecordContactInformationModel> | null | undefined,
  user: UserModel | null | undefined,
): boolean {
  if (!user) {
    return false;
  }

  const userFirst: string = normalizeIorText(user.firstName);
  const userLast: string = normalizeIorText(user.lastName);
  const userEmail: string = normalizeIorText(user.email);
  const userPhone: string = normalizeIorPhone(user.phoneNumber);

  if (!userFirst && !userLast && !userEmail && !userPhone) {
    return false;
  }

  if (!userPhone) {
    return false;
  }

  return (
    normalizeIorText(ior?.firstName) === userFirst &&
    normalizeIorText(ior?.lastName) === userLast &&
    normalizeIorText(ior?.emailAddress) === userEmail &&
    normalizeIorPhone(ior?.phoneNumber) === userPhone
  );
}
